/**
 * Functions to hook Google Analytics events to on page actions
 */

/* global gtag */
/* global gaVars */
/* exported handleRender, gtagEvent, gtagEventHandler */
jQuery(document).ready(function ($) {
    if ((typeof gaVars === 'object')) {

        // Click event
        $(document).on('click', 'a', function (event) {
            var $target = $(event.target);

            // Check if it's an <a> tag with specific file types
            // Ignore exports from amcharts4
            if ($target.closest('.amcharts-amexport-menu').length) {
                return;
            }

            var href = $target.closest('a').prop('href');

            // If href is empty or does not exist then don't trigger an event
            if (!href) {
                return;
            }

            var txt = $.trim($target.text());

            // Check for an outbound link (including blob when images are downloaded from Amcharts4 export menu)
            var domainsString = gaVars.domains.join('|').replace(/\./g, '\\.');
            var matchDomain = new RegExp('^(?:blob:)?(http(s)?:)?//(www\\.)?(' + domainsString + ')', 'i');


            // If target URL is internal, check for download files
            if (href.match(matchDomain)) {
                let eventName;
                let eventLabel = txt;
                let eventTarget = href.replace(gaVars.baseUrl, '');

                var contentType = 'Uncategorized - ' + gaVars.activeLang;
                if (typeof $target.attr('data-content-type') !== 'undefined') {
                    contentType = $target.attr('data-content-type');
                }

                // Set event name e.g. download_pdf, download_docx
                var match = href.match(/\.(pdf|docx)(\?|#|$)/i);
                if (match) {
                    // Capture extension name with match[1]
                    eventName = 'download_' + match[1];
                    gtag('event', eventName, {
                        'event_label': eventLabel,
                        'event_content_type': contentType,
                        'event_target': eventTarget
                    });
                }
            } else {
                // If target URL is from a different domain send outbound_click event to GA
                gtag('event', 'outbound_click', {
                    'event_label': txt,
                    'event_target': href
                });
            }
        });

        $(document).on('click', '.ga-event', function(event) {
            var $target = $(event.target);
            var slug = gaVars.baseUrl;
            if (gaVars.baseUrl !== gaVars.pageUrl) {
                slug = gaVars.pageUrl.replace(gaVars.baseUrl, '');
            }
            var eventAction = $target.data('gaAction');
            var eventCategory = $target.data('gaCategory');

            // Use slug as the label by default unless is specified in data-ga-label
            var eventLabel = $target.data('gaLabel') ?? slug;

            gtagEvent(eventCategory, eventAction, eventLabel);
        });

        // Check language switcher
        $(document).on('click', ".lang-analytics", function (event) {
            var $target = $(event.target);
            var eventName = $target.attr('lang') === 'en' ? 'switch_to_english' : 'switch_to_french';
            gtag('event', eventName);
        });

        //fires event when search page loads
        if ($("#bocss-search__input").length > 0) {
            var results = filtersUrlParams();
            var previousPage = document.referrer;
            var bUrl = gaVars.baseUrl;


            if (previousPage.startsWith(bUrl)) {
                previousPage = previousPage.replace(bUrl, "");
                if (previousPage === '') {
                    previousPage = '/';
                }
            }

            gtag('event', "view_search_results", {
                'search_term': results['search_term'],
                'previous_page': previousPage
            });
        }

        //sends event to ga4 when there is a change in filters or in the search bar
        $('body').on('change', '.ga-event-filter', function (event) {
            $('#bocss-search__input').ready(function () {

                var results = filtersUrlParams();
                results['search_filter_triggered'] = event.target.name;
                gtag('event', "view_search_results", results);
            });
        });

        // Amcharts3
        $(document).on('click', 'li.amcharts-ga-event', function (event) {
            var $target = $(event.target);
            var slug = gaVars.baseUrl;
            if (gaVars.baseUrl !== gaVars.pageUrl) {
                slug = gaVars.pageUrl.replace(gaVars.baseUrl, '');
            }
            //navigates to the main div and gets the ID
            var chartID = $target.parents('div.amcharts-main-div').parent().attr('id');

            //create complete event description
            var eventAction = window[chartID]['titles'][0]['text'] + ' ' + event.target.innerText;
            var eventCategory = 'AmCharts';
            gtagEvent(eventCategory, eventAction, slug);
        });
    }
});

/**
 * function to send a GA event when an AmChart has been rendered
 * @param {object} event     The AMChart render event
 * @returns {void}
 */
function handleRender(event) {
    if ((typeof gaVars === 'object')) {
        var slug = gaVars.baseUrl;
        if (gaVars.baseUrl !== gaVars.pageUrl) {
            slug = gaVars.pageUrl.replace(gaVars.baseUrl, '');
        }

        var chartTitle = '';
        if (event.chart.titles.length > 0) {
            chartTitle = event['chart']['titles'][0]['text'];
        } else {
            chartTitle = 'no title';
        }
        var eventAction = chartTitle + ' View';
        var eventCategory = 'AmCharts';
        gtagEvent(eventCategory, eventAction, slug);
    }
}

/**
 * function to send a GA event
 * @param {string} eventCategory Category
 * @param {string} eventAction Action
 * @param {string} eventLabel Label (optional)
 * @returns {void}
 */
function gtagEvent(eventCategory, eventAction, eventLabel) {
    if (typeof gaVars === 'object' && typeof window.dataLayer === 'object') {
        if (eventLabel === null) {
            gtag('event', eventAction, {
                'event_category': eventCategory
            });
        } else {
            gtag('event', eventAction, {
                'event_category': eventCategory,
                'event_label': eventLabel
            });
        }
    }
}

/**
 * function to send a GA event
 * @param {object} data Category
 * @returns {void}
 */
function gtagEventHandler(data) {
    gtagEvent(data.eventCategory, data.eventAction, data.eventLabel);
}

/**
 * function to set up the tag event and call it
 * @param {object} element DOM element containing metadata
 * @param {string} eventCategory the name of the event category
 * @returns {void}
 **/
function setTagEvent(element, eventCategory) {
    var filePath = element.text() + ' ~~ ' + element.attr('href').replace(gaVars.baseUrl, '');
    var contentType = 'Uncategorized - ' + gaVars.activeLang;
    if (typeof element.attr('data-content-type') !== 'undefined') {
        contentType = element.attr('data-content-type');
    }
    gtagEvent(eventCategory, contentType, filePath);
}

/**
 * function that finds the value of the filter(s) used from the url and saves it in results.
 * @returns {object} results
 **/
function filtersUrlParams() {
    var queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    var trackedTerms = {
        'q_topic': 'topic[]',
        'q_content_type': 'content_type[]',
        'q_jel': 'jel[]',
        'q_location': 'location[]',
        'q_department': 'department[]',
        'q_profile_post': 'profile_post[]',
        'q_source': 'source[]',
        'q_statuses': 'statuses[]',
        'q_mtf_date_after': 'mtf_date_after',
        'q_mtf_date_before': 'mtf_date_before',
        'search_term': 'esearch'
    };

    var results = {};
    for (var prop in trackedTerms) {
        for (var key of urlParams.keys()) {
            if (key === trackedTerms[prop] && urlParams.getAll(key).toString() !== '') {
                results[prop] = urlParams.getAll(key).toString();
            }
        }
    }
    return results;
}
